import { vnModule_knockoutJS } from '../../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { header } from '../header';
import { adminCreativeEdit_template } from '../../components/templates/recruiting/adminCreativeEdit_template';
import { hideLoadingOverlay, showLoadingOverlay } from '~/utils/listLoading';
export class admin_creative_edit extends vnModule_knockoutJS {
    getModuleName() {
        return 'admin_creative_edit';
    }
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle('Creative');
        this.tpl = new adminCreativeEdit_template('adminCreativeEditTemplate', this.viewModel, this);
        this.template = this.tpl;
        return [this.tpl.build()];
    }
    fillPage() {
        const creativeId = this.getCreativeId();
        if (!creativeId) {
            const partnerId = this.getQueryParam('partnerId');
            this.tpl.setCreative({ partnerId: partnerId ? Number(partnerId) : null, status: 1 });
            return;
        }
        this.loadCreative(creativeId);
    }
    async loadCreative(creativeId) {
        showLoadingOverlay(this.tpl.builtTemplate, 'Loading creative...');
        const response = await fetch('/api/admin/rest/api/lead/offer/creative/' + creativeId, {
            credentials: 'same-origin',
        });
        const payload = await response.json();
        hideLoadingOverlay(this.tpl.builtTemplate);
        if (!response.ok) {
            alert('Unable to load creative.');
            return;
        }
        this.tpl.setCreative(payload, this.isDuplicate());
    }
    async saveCreative() {
        const payload = this.tpl.getPayload();
        if (!payload.partnerId) {
            alert('Partner ID is required.');
            return;
        }
        showLoadingOverlay(this.tpl.builtTemplate, 'Saving creative...');
        const response = await fetch('/api/admin/rest/api/lead/offer/creative', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ creative: payload }),
        });
        const result = await response.json();
        hideLoadingOverlay(this.tpl.builtTemplate);
        if (!response.ok || Number(result.status || 0) !== 200) {
            alert(result.message || 'Unable to save creative.');
            return;
        }
        page('/admin/creative/' + result.objectId);
    }
    async deleteCreative() {
        const creativeId = this.getCreativeId();
        if (!creativeId || !confirm('Archive this creative?')) {
            return;
        }
        showLoadingOverlay(this.tpl.builtTemplate, 'Archiving creative...');
        const response = await fetch('/api/admin/rest/api/lead/offer/creative/' + creativeId, {
            method: 'DELETE',
            credentials: 'same-origin',
        });
        hideLoadingOverlay(this.tpl.builtTemplate);
        if (!response.ok) {
            alert('Unable to archive creative.');
            return;
        }
        page('/admin/creativeList');
    }
    async uploadCreativeIcon(size, event) {
        const creativeId = this.getCreativeId();
        const input = event && event.target ? event.target : null;
        const file = input && input.files && input.files.length ? input.files[0] : null;
        if (!creativeId) {
            alert('Save the creative before uploading images.');
            if (input) {
                input.value = '';
            }
            return;
        }
        if (!file) {
            return;
        }
        const formData = new FormData();
        formData.append('file', file);
        showLoadingOverlay(this.tpl.builtTemplate, 'Uploading creative image...');
        const response = await fetch('/api/admin/rest/api/lead/offer/' + creativeId + '/icon/' + size, {
            method: 'POST',
            credentials: 'same-origin',
            body: formData,
        });
        const result = await response.json();
        hideLoadingOverlay(this.tpl.builtTemplate);
        if (input) {
            input.value = '';
        }
        if (!response.ok || Number(result.status || 0) !== 200) {
            alert(result.message || 'Unable to upload creative image.');
            return;
        }
        this.loadCreative(creativeId);
    }
    backToCreatives() {
        page('/admin/creativeList');
    }
    getCreativeId() {
        const id = this.getVnAppZone().app.params.id;
        return id && id !== 'new' ? Number(id) : 0;
    }
    getQueryParam(name) {
        const params = new URLSearchParams(window.location.search || '');
        return params.get(name) || '';
    }
    isDuplicate() {
        return String(document.location.pathname || '').includes('/admin/creative-duplicate/');
    }
}
